module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('top', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "content"
  }), _vm._v(" "), _c('bottom')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fd241d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1022
// module chunks = 0